module.exports = __webpack_public_path__ + "03052a1ee2cfc8daae1afe6b2916448d.svg";